<template>
  <div class="mode12-wrap">
    <div class="mode12-header">
      <div
        class="title-header"
        v-exposure="{ eid: `101_24_${this.curindex}_0` }"
        :data-id="`101_24_${this.curindex}_0`"
      >
        {{ $t("Datalang.Latest_bets_Race") }}
      </div>
      <div class="mode12-tabs">
        <div
          class="mode12-tabs-item ellipsis"
          :class="{ active: active === 1 }"
          @click="handleItem(1, `101_0_0_135`)"
          v-exposure="{ eid: `101_0_0_135` }"
          :data-id="`101_0_0_135`"
        >
          {{ $t("Datalang.Hight_rollers") }}
        </div>
        <div
          class="mode12-tabs-item ellipsis"
          :class="{ active: active === 0 }"
          @click="handleItem(0, `101_0_0_134`)"
          v-exposure="{ eid: `101_0_0_134` }"
          :data-id="`101_0_0_134`"
        >
          {{ $t("Datalang.Latest_bets") }}
        </div>

        <div
          v-if="isInActivity"
          class="mode12-tabs-item ellipsis"
          :class="{ active: active === 2 }"
          @click="handleItem(2, `101_0_0_136`)"
          v-exposure="{ eid: `101_0_0_136` }"
          :data-id="`101_0_0_136`"
        >
          {{ $t("Datalang.Invite_BTM_rankings") }}
        </div>
      </div>
    </div>
    <!-- <div v-if="!IsMobile" style="height: 20px"></div> -->
    <div class="mode12-list" v-if="active === 0 || active === 1">
      <template v-if="!IsMobile">
        <table style="width: 100%">
          <thead>
            <tr>
              <td class="text-left" style="width: 25%">
                {{ $t("Datalang.Betrecord_TITLE_game") }}
              </td>
              <td class="text-center" style="width: 20%">
                {{ $t("Datalang.Leaderboard_Player") }}
              </td>
              <td class="text-center" style="width: 20%">
                {{ $t("Datalang.Bet_Amount") }}
              </td>
              <td class="text-center" style="width: 15%">
                {{ $t("Datalang.Multiplier_Home") }}
              </td>
              <td class="text-right" style="width: 20%">
                {{ $t("Datalang.Profit_Amount") }}
              </td>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
        <div class="scrollWrap" @click="handleParentClick">
            <vue-seamless-scroll
              :data="formatList"
              ref="seamlessScroll"
              :class-option="classOption"
              @ScrollEnd="ScrollEnd"
              class="no-rem_warp-scroll"
            >
              <div
                v-for="(item, i) in formatList"
                :key="i"
                :data-key="item.key"
                class="pointer no-rem_warp-scroll-item trdiv"
              >
                <div class="tddiv" :data-key="item.key" style="width: 25%">
                  <div class="name-wrap" :data-key="item.key">
                    <img
                      v-if="item.gamePcIcon"
                      :data-key="item.key"
                      :src="$utils.returnImgUrl(item.gamePcIcon)"
                      alt=""
                      class="game-icon"
                    />
                    <span :data-key="item.key">{{ item.gameName }}</span>
                  </div>
                </div>
                <div class="tddiv text-center" :data-key="item.key" style="width: 20%">{{ item.userName }}</div>
                <div class="tddiv text-center color-desc" :data-key="item.key" style="width: 20%">
                  {{ divideSymbol(item.betAmount) }}
                </div>
                <div class="tddiv text-center color-desc" :data-key="item.key" style="width: 15%">
                  {{ divideSymbol(item.multiple) }}x
                </div>
                <div
                  class="text-right rate-style tddiv"
                  :data-key="item.key"
                  :class="item.gameRewardAmount > 0 ? 'color-green' : 'color-origin'"
                  style="width: 20%"
                >
                  <span :data-key="item.key">{{ divideSymbol(item.gameRewardAmount) }}</span>
                  <img
                    :data-key="item.key"
                    v-if="item.coin_icon"
                    :src="$utils.returnImgUrl(item.coin_icon)"
                    class="coin_code"
                    alt=""
                    srcset=""
                  />
                </div>
              </div>
            </vue-seamless-scroll>
        </div>
      </template>
      <template v-if="IsMobile">
        <table style="width: 100%">
          <thead>
            <tr>
              <td class="text-left" style="width: 40%">
                {{ $t("Datalang.Betrecord_TITLE_game") }}
              </td>
              <td class="text-center" style="width: 25%">
                {{ $t("Datalang.Multiplier_Home") }}
              </td>
              <td class="text-right" style="width: 35%">
                {{ $t("Datalang.Profit_Amount") }}
              </td>
            </tr>
          </thead>
        </table>
        <div class="scrollWrap" @click="handleParentClick">
            <vue-seamless-scroll
              :data="formatList"
              ref="seamlessScroll"
              :class-option="classOptionH5"
              class="no-rem_warp-scroll"
            >
              <div
                v-for="(item, i) in formatList"
                :key="i"
                :data-key="item.key"
                class="pointer no-rem_warp-scroll-item trdiv"
              >
                <div class="tddiv" :data-key="item.key" style="width: 40%">
                  <div class="name-wrap" :data-key="item.key">
                    <img
                      v-if="item.gamePcIcon"
                      :data-key="item.key"
                      :src="$utils.returnImgUrl(item.gamePcIcon)"
                      alt=""
                      class="game-icon"
                    />
                    <span :data-key="item.key">{{ item.gameName }}</span>
                  </div>
                </div>
                <div class="tddiv text-center" :data-key="item.key" style="width: 25%">
                  {{ divideSymbol(item.multiple) }}x
                </div>
                <div
                  class="text-right rate-style tddiv"
                  :data-key="item.key"
                  :class="item.gameRewardAmount > 0 ? 'color-green' : 'color-origin'"
                  style="width: 35%"
                >
                  <span :data-key="item.key">{{ divideSymbol(item.gameRewardAmount) }}</span>
                  <img
                    v-if="item.coin_icon"
                    :data-key="item.key"
                    :src="$utils.returnImgUrl(item.coin_icon)"
                    class="coin_code"
                    alt=""
                    srcset=""
                  />
                </div>
              </div>
            </vue-seamless-scroll>
        </div>
      </template>
    </div>
    <div v-if="active === 2" :style="`margin-bottom: ${$px2rem(20)}`">
      <RankMode2 :isShowRank="true" :style="`padding-bottom: ${$px2rem(20)}`" />
    </div>
    <!-- 跳转游戏 -->
    <jpDetailDialog ref="jpDetailDialog" />
  </div>
</template>
<script>
import mode12 from "@/lobby_common/mixins_views/homeModule/mode12.js";
import RankMode2 from "@/components/rankList/RankMode2";
import jpDetailDialog from "./jpDetailDialog.vue";

export default {
  components: {
    RankMode2,
    jpDetailDialog,
  },
  name: "Mode12",
  mixins: [mode12],
};
</script>
<style lang="scss" scoped>
.mode12-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
}
.mode12-wrap {
  margin: 20px 0px 40px 0px;

  @media (max-width: 768px) {
    margin: 0 auto;
    width: calc(100% - 24px);
    background: none;
    margin-top: 10px;
    padding: 0;
    box-sizing: border-box;
    border-radius: var(--radius-401);
    margin-bottom: 30px;
  }
  .title-header {
    font-size: 18px;
    padding: 20px 0;
    font-weight: bold;
    color: var(--font-color-1601);
    @media (max-width: 768px) {
      font-size: 15px;
      padding: 8px 0;
    }
  }
  .mode12-tabs {
    position: relative;
    border-radius: var(--radius-100);
    overflow: hidden;
    background: var(--button-600);
    display: inline-flex;
    align-items: center;
    @media (max-width: 768px) {
      width: 100%;
      border-radius: var(--radius-401);
    }
    .mode12-tabs-item {
      min-width: 120px;
      line-height: 52px;
      text-align: center;
      color: var(--font-color-600);
      cursor: pointer;
      transition: all ease 0.3s;
      padding: 0 15px;
      @media (max-width: 768px) {
        line-height: 28px;
        height: 28px;
        width: 33.33%;
        font-size: 14px;
        background: var(--button-600);
        min-width: 100px;
        padding: 0 5px;
        border-radius: var(--radius-401);
      }
      &.active {
        background: var(--button-700);
        color: var(--font-color-700);
        border-radius: var(--radius-100);
        @media (max-width: 768px) {
          border-radius: var(--radius-401);
        }
      }
    }
  }
  .no-rem_warp-scroll,
  .mode12-list {
    margin: 0px 0;
    height: 550px;
    background: var(--background-801);
    border-radius: var(--radius-400);
    .no-rem_warp-scroll {
      width: 100%;
      height: 500px;
      padding: 0 20px;
      box-sizing: border-box;
      overflow: hidden;
      position: relative;
      line-height: 50px;
      font-size: 14px;
      @media (max-width: 768px) {
        padding: 0 5px;
        line-height: 30px;
        font-size: 12px;
      }
      &-item {
        display: flex;
        align-items: center;
        .trdiv {
          box-sizing: border-box;
        }
        .tddiv {
          padding: 0 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          @media (max-width: 768px) {
            padding: 0;
          }

          &.mobile-right {
            display: flex;
            overflow: hidden;
            box-sizing: border-box;
            text-overflow: unset;
            white-space: unset;
            justify-content: flex-end;
            align-items: center;
          }
        }
      }
    }
    @media (max-width: 768px) {
      height: 360px;
      margin: 14px 0px 0px 0px;
      overflow: hidden;
      padding: 0 10px;
      border-radius: var(--radius-401);
      background: var(--background-801);
    }
    table {
      font-size: 14px;
      line-height: 40px;
      padding: 0 30px;
      box-sizing: border-box;
      table-layout: fixed;
      @media (max-width: 768px) {
        padding: 0;
        line-height: 25px;
        font-size: 12px;
      }
      tr {
        box-sizing: border-box;
      }
      td {
        padding: 0 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-width: 768px) {
          padding: 0;
        }
        &.mobile-right {
          display: flex;
          overflow: hidden;
          box-sizing: border-box;
          text-overflow: unset;
          white-space: unset;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
    table thead tr {
      color: var(--font-color-900);
    }
    table tbody tr {
      color: var(--font-color-100);
    }
    .name-wrap {
      display: flex;
      align-items: center;
      > span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .game-icon {
        margin-right: 5px;
        width: 20px;
        height: 20px;
        border-radius: 5px;
      }
    }
    .coin_code {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-left: 5px;
    }
  }
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.rate-style {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.text-center {
  text-align: center;
}
.color-desc {
  // color: var();
}
.color-origin {
  color: var(--font-color-1500);
}
.color-green {
  color: var(--font-color-1000);
}
.pointer {
  cursor: pointer;
  border-radius: var(--radius-400);
}
.pointer:hover {
  background: var(--background-900);
  height: 100%;
  width: 100%;
}
</style>
